import { render } from "./product-overview.vue?vue&type=template&id=5539413c"
import script from "./product-overview.js?vue&type=script&lang=js&external"
export * from "./product-overview.js?vue&type=script&lang=js&external"

import "./product-overview.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__